module.exports = __webpack_public_path__ + "media/images/font/TradeGothicNextLTPro-BdCn-2dbf6d38f7855a8716d2d34df9ed10ec.ttf";